import { GetStaticProps } from 'next';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SWRConfig } from 'swr';

import TermsAndCondition from '@components/organisms/cpd/termsAndCondition';
import Seo from 'src/components/atoms/seo';
import Main from 'src/components/templates/main';
import config from 'src/config';

const CpdTerms = ({ fallback }: any) => (
  <SWRConfig value={{ fallback }}>
    <Main scrollToTop isFooterCpd>
      <Seo
        title="SkillLaneCPD | หลักสูตรอบรมเก็บชั่วโมงออนไลน์ทางวิชาชีพ"
        description="SkillLaneCPD | หลักสูตรอบรมเก็บชั่วโมงออนไลน์ สำหรับคนกลางประกันภัย ผู้เเนะนำการลงทุน ฯลฯ รับรองหลักสูตรโดย OIC (คปภ.) และ TSI"
        image_url={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/seo-thumbnail-cpd.jpg`}
      />
      <TermsAndCondition />
    </Main>
  </SWRConfig>
);

type Params = {
  locale: string;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context as Params;
  return {
    props: {
      fallback: {},
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: config.REVALIDATE_SHORT,
  };
};

export default CpdTerms;
